module.exports = __webpack_public_path__ + "static/media/ListTestingIcon.62a7ff84.svg";